import * as Sentry from '@sentry/react';

export function SentryCaptureException(error: Error) {
        Sentry.captureException(error, {
			tags: {
				priority: 'urgent',
			},
			level: "fatal",
			extra: {
				timestamp: new Date().toISOString(),
				userAgent: navigator.userAgent,
				url: window.location.href,
			},
		})
}
